export default __webpack_public_path__ + "static/media/fireFN11.f8618a00.svg";